import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

export default function ProductContainer() {
  const { id } = useParams();

  useEffect(() => {
    if (!id) return;

    // RN linking.config 와 일치하도록 plural(products) 사용
    const deepLink = `xinvana://products/${id}`;
    const storeUrl =
      "https://play.google.com/store/apps/details?id=com.prinmann.xinvana";

    // 앱 실행 시도
    window.location.href = deepLink;

    // 앱 미설치 → 일정 시간 후 스토어 이동
    const timer = setTimeout(() => {
      // 앱이 실행되면 브라우저가 백그라운드로 가므로,
      // 여전히 페이지가 보이는 경우(=앱 미설치)만 스토어 이동
      if (document.visibilityState === "visible") {
        window.location.href = storeUrl;
      }
    }, 1500);

    return () => clearTimeout(timer);
  }, [id]);

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>상품 상세 페이지 이동 중...</h1>
      <p>상품 {id}을(를) 열고 있습니다. 잠시만 기다려주세요.</p>
    </div>
  );
}
